module.exports = __webpack_public_path__ + "static/favicons/mstile-310x310-129078211d07349df01f24f57b49965b.png";